import { render, staticRenderFns } from "./truck-summary.vue?vue&type=template&id=1904e3f2&scoped=true&"
import script from "./truck-summary.component.ts?vue&type=script&lang=ts&"
export * from "./truck-summary.component.ts?vue&type=script&lang=ts&"
import style0 from "./truck-summary.scss?vue&type=style&index=0&id=1904e3f2&lang=scss&scoped=true&"
import style1 from "./truck-summary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904e3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1904e3f2')) {
      api.createRecord('1904e3f2', component.options)
    } else {
      api.reload('1904e3f2', component.options)
    }
    module.hot.accept("./truck-summary.vue?vue&type=template&id=1904e3f2&scoped=true&", function () {
      api.rerender('1904e3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/truck-summary/truck-summary.vue"
export default component.exports